export default {
  SET_TECHNOLOGY: function (state, payloads) {
    state.technologies = payloads;
  },
};
